/* eslint-disable max-len */
/**
 * Finnish translations.
 */
export default {
  ACTION: {
    CAMPAIGNS: 'Kampanjat',
    CERTIFICATES: 'Todistukset',
    CHALLENGES: 'Haasteet',
    CHAT: 'Chat',
    CLOSE: 'Sulje',
    CLUB: 'Klubi',
    COMMISSIONED_PRODUCTS: 'Tilatut tuotteet',
    COMMUNICATIONS: 'Viestintä',
    CONFIRM: 'Vahvista',
    COUNTERPART: 'Vastapuolet',
    DASHBOARD: 'Ohjauspaneeli',
    DESIGN_REQUESTS: 'Suunnittelupyynnöt',
    DETAILS: 'Yleisiä tietoja',
    EXTERNAL_APPLICATIONS: 'Ulkoiset sovellukset',
    FOLLOWER_MESSAGES: 'Viestit Seuraajat',
    GENERICS: 'Yleiset',
    LINKS: 'Linkit',
    LIVE: 'Suora',
    LOGOUT: 'Poistu',
    MEMBERS: 'Kumppanit',
    MENTIONS: 'Maininnat',
    OFFERS: 'Tarjoukset',
    ON_DEMAND_CAMPAIGNS: 'Tilauskampanjat',
    OPPORTUNITIES: 'Mahdollisuudet',
    ORDERS: 'Maksetut tilaukset',
    PARTNERS: 'Kumppanit',
    PERSONAL_AREA: 'Henkilökohtainen alue',
    PRODUCTS_OFFERED: 'Tarjotut tuotteet',
    PROFILE: 'Profiili',
    PROZIS_COMMUNITY: 'Prozis-yhteisö',
    QUESTIONS: 'Kysymykset',
    REMUNERATIONS: 'Palkkaus',
    SELECT_LANGUAGE: 'Valitse kieli',
    SELECT_PARTNER: 'Valitse toinen kumppani',
    SERVICES: 'Palvelut',
    SOCIAL_NETWORK: 'Prozis sosiaalinen verkosto',
    STATISTICS: 'Tilastot',
    VIDEO_TUTORIALS: 'Video-oppaat'
  },
  ERROR: {
    ERROR: 'Virhe',
    FETCH_DATA: 'Hae tiedot'
  },
  HEADER: {},
  LABEL: {
    CAMPAIGNS: 'Kampanjat',
    CHALLENGES: 'Haasteet',
    CHAT: 'Chat',
    COMMUNICATIONS: 'Viestintä',
    COUNTERPARTS: 'Vastapuolet',
    DASHBOARD: 'Ohjauspaneeli',
    DESIGN_REQUESTS: 'Suunnittelupyynnöt',
    DETAILS: 'Yksityiskohdat',
    EXTERNAL_APPLICATIONS: 'Ulkoiset sovellukset',
    FILTER: 'Suodatin',
    FILTERED: 'Suodatettu',
    FOLLOWER_MESSAGES: 'Viestit Seuraajat',
    GENERICS: 'Yleiset',
    HOME: 'Takaisin',
    LINKS: 'Linkit',
    LOGOUT: 'Poistu',
    MEMBERS: 'Kumppanit',
    MENTIONS: 'Instagram-maininnat',
    NOT_FOUND: '404, Oletko eksyksissä?',
    OFFERS: 'Tarjoukset',
    ORDERS: 'Tilaaminen',
    PARTNERSHIP_NOT_FOUND: 'Kumppania ei löytynyt.',
    PENDING_COUNTERPART: 'Edellisen kauden vireillä olevat vastapuolet',
    PENDING_COUNTERPART_CURRENT: 'Kuluvan kuukauden maksamattomat vastapuolet',
    PENDING_REMUNERATION: 'Edelliseltä kaudelta maksamattomat palkat',
    PENDING_REMUNERATION_CURRENT: 'Kuluvan kuukauden maksamatta olevat maksut',
    PERSONAL_AREA: 'Henkilökohtainen alue',
    PRODUCTS: 'Tuotteet',
    REMUNERATIONS: 'Palkkaus',
    SEARCH_PARTNERSHIP: 'Kumppania etsimässä',
    SELECT_LANGUAGE: 'Valitse kieli',
    SELECT_PARTNERSHIP: 'Valitse kumppani',
    UNAUTHROZIED: '403, Luvaton pääsy!!!!'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
